module.exports = __webpack_public_path__ + "img/check.9267fb68.svg";